import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    question: '¿Cómo recibo el kit?',
    answer: 'El acceso es inmediato luego de completar el pago. Recibirás un correo electrónico con el enlace de descarga para que puedas empezar hoy mismo.'
  }, {
    question: '¿Es un producto físico?',
    answer: 'No. Es un producto digital (PDF y recursos complementarios) diseñado para que puedas descargarlo y utilizarlo desde cualquier dispositivo (celular, tablet o computadora).'
  }, {
    question: '¿Necesito conocimientos previos?',
    answer: 'No. Está pensado para cualquier persona que quiera comenzar a trabajar en su bienestar emocional, sin importar su experiencia previa en procesos terapéuticos o de autoconocimiento.'
  }, {
    question: '¿Cuánto tiempo tendré acceso?',
    answer: 'El acceso es de por vida. Una vez que lo descargás, el material es tuyo para siempre y podés volver a él cada vez que lo necesites.'
  }, {
    question: '¿Cómo realizo el pago?',
    answer: 'Podés pagar mediante Mercado Pago, tarjetas de crédito, débito y otros medios habilitados de forma segura en nuestra plataforma de checkout.'
  }];
  return <section id="faq" className="py-24 bg-[#2C2541] relative z-10 pt-[0px] pb-[0px]" data-id="element-102">
      <div className="max-w-4xl mx-auto px-4" data-id="element-103">
        <div className="text-center mb-16" data-id="element-104">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#D9B15F]/10 border border-[#D9B15F]/30 text-[#D9B15F] text-sm font-medium mb-6" data-id="element-105">
            <HelpCircle className="w-4 h-4" data-id="element-106" />
            <span data-id="element-107">Despejá tus dudas</span>
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#D9B15F] mb-4" data-id="element-108">
            Preguntas Frecuentes
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-109">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="rounded-2xl border border-[#D9B15F]/10 bg-[#3A3158]/20 overflow-hidden" data-id="element-110">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full p-6 text-left flex items-center justify-between gap-4 hover:bg-[#3A3158]/40 transition-colors" data-id="element-111">
                <span className="text-lg font-bold text-[#F8F5F2]" data-id="element-112">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-[#D9B15F] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-113" />
              </button>
              <AnimatePresence data-id="element-114">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-115">
                    <div className="px-6 pb-6 text-[#B99BE8] leading-relaxed border-t border-[#D9B15F]/10 pt-4" data-id="element-116">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}